import React, { useState } from 'react';
import { FaTruck, FaPlane, FaMapMarkerAlt, FaSort, FaSearch, FaBoxOpen, FaPalette, FaShip, FaPallet } from 'react-icons/fa';
import generateRandomShipments from '../utils/shipmentGenerator';

function ShipmentTable() {
    const [searchTerm, setSearchTerm] = useState('');

    const shipments = generateRandomShipments();
 


    return (
        <div className="bg-white p-8 rounded-lg shadow-xl font-sans w-full transition-transform transform">
            {/* Search */}
            <div className="mb-6 flex items-center border-b-2 pb-2">
                <FaSearch className="mr-3 text-gray-500" />
                <input
                    className="w-full focus:outline-none text-gray-700"
                    placeholder="Search shipments..."
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                />
            </div>

            {/* Table */}
            <table className="min-w-full bg-white border border-gray-300">
                <thead>
                    <tr>
                        <th className="py-3 px-4 border-b-2 border-gray-300 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Shipment No. <FaSort className="inline text-gray-500 ml-2" />
                        </th>
                        <th className="py-3 px-4 border-b-2 border-gray-300 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Origin/Destination <FaSort className="inline text-gray-500 ml-2" />
                        </th>
                        <th className="py-3 px-4 border-b-2 border-gray-300 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Modality <FaSort className="inline text-gray-500 ml-2" />
                        </th>
                        <th className="py-3 px-4 border-b-2 border-gray-300 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Status <FaSort className="inline text-gray-500 ml-2" />
                        </th>
                        <th className="py-3 px-4 border-b-2 border-gray-300 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Shipper/Consignee <FaSort className="inline text-gray-500 ml-2" />
                        </th>
                        <th className="py-3 px-4 border-b-2 border-gray-300 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Package <FaSort className="inline text-gray-500 ml-2" />
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {shipments.map((shipment, index) => (
                        <tr className={`${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}>
                            <td className="py-2 px-4 border-b border-gray-200">{shipment.shipmentNumber}</td>
                            <td className="py-2 px-4 border-b border-gray-200">
                                <div className="flex items-center">
                                    <FaMapMarkerAlt className="mr-2 text-blue-500" />
                                    {shipment.origin} / {shipment.destination}
                                </div>
                            </td>
                            <td className="py-2 px-4 border-b border-gray-200 flex items-center">
                                {shipment.modality === "AIR" && <FaPlane className="mr-2 text-blue-500" />}
                                {shipment.modality === "GROUND" && <FaTruck className="mr-2 text-blue-500" />}
                                {shipment.modality === "SEA" && <FaShip className="mr-2 text-blue-500" />}
                                <span>{shipment.modality}</span>
                            </td>
                            <td className={`py-2 px-4 border-b border-gray-200 ${shipment.statusColor}`}>{shipment.status}</td>
                            <td className="py-2 px-4 border-b border-gray-200">{shipment.shipper} / {shipment.consignee}</td>
                            <td className="py-2 px-4 border-b border-gray-200 flex items-center">
                                {shipment.packageType === "boxes" && <FaBoxOpen className="mr-2 text-blue-500" />}
                                {shipment.packageType === "pallet" && <FaPallet className="mr-2 text-blue-500" />}
                                {shipment.packageType === "container" && <FaShip className="mr-2 text-blue-500" />}
                                {shipment.packageQuantity}x {shipment.packageType}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default ShipmentTable;
